import { type PatientDetail, reportProgress } from '#shared/types';
import type { Column } from '#client/components/ui/DataTable';
import { DueCell } from '#client/components/ui/DueCell';
import { Progress } from '#client/components/ui/Progress';
import { ReportStatusBadge } from '#client/components/ui/StatusBadge';
import { formatMoney } from '#client/lib/format';

type PatientReport = PatientDetail['reports'][number];

/**
 * The reports table on a patient record.
 *
 * At module scope, like every other column array in the app, so it is not
 * reallocated on every render.
 */
export const patientReportColumns: Column<PatientReport>[] = [
  {
    key: 'name',
    header: 'Report',
    render: (row) => <strong>{row.name}</strong>,
    frozen: true,
    width: '15rem',
  },
  {
    key: 'progress',
    header: 'Results',
    render: (row) => <Progress {...reportProgress(row)} />,
    width: '130px',
  },
  {
    key: 'due',
    header: 'Due',
    render: (row) => <DueCell {...row} />,
    width: '170px',
  },
  {
    key: 'status',
    header: 'Status',
    render: (row) => <ReportStatusBadge status={row.report_status} />,
    width: '140px',
  },
  {
    key: 'price',
    header: 'Price',
    render: (row) => formatMoney(row.price),
    align: 'end',
    width: '110px',
  },
];
